const appConfig = {
    apiPrefix: '/api',
    authenticatedEntryPath: '/dashboard',
    unAuthenticatedEntryPath: '/',
    tourPath: '/',
    enableMock: false,
    bonusWords:0
}

export default appConfig